export default __webpack_public_path__ + "static/media/person-2.713ea21b.png";